<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu
      pageTitle="create_quotation"
      :items="breadcrumbItems"
      :showHome="false"
    />

    <div v-if="isLoadingData" class="card border-0 shadow-none rounded-1 mb-25">
      <div class="card-body p-xl-40 text-center text-muted">
        {{ $t("quotation_page.loading_quotation_form") }}
      </div>
    </div>

    <QuotationForm
      v-else
      :form="form"
      :customers="customers"
      :warehouses="warehouses"
      :search-query="searchQuery"
      :search-results="searchResults"
      :show-results="showResults"
      :total-items="totalItems"
      :total-cost="totalCost"
      :calculated-discount="calculatedDiscount"
      :calculated-tax="calculatedTax"
      :grand-total="grandTotal"
      :is-submitting="isSubmitting"
      :warehouse-locked-to-profile="warehouseLockedToProfile"
      :lock-auto-fields="true"
      @update-field="handleUpdateField"
      @update-search="handleSearchInput"
      @add-product="addProduct"
      @update-qty="updateQty"
      @set-qty="updateItemQuantity"
      @remove-item="removeItem"
      @submit="submitQuotation"
    />

    <div class="flex-grow-1"></div>
    <MainFooter />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import QuotationForm from "../../components/Quotations/CreateQuotation/QuotationForm.vue";
import { useCreateQuotationForm } from "../../composables/useQuotation";

export default defineComponent({
  name: "CreateQuotationPage",
  components: {
    MainHeader,
    MainSidebar,
    BreadcrumbMenu,
    MainFooter,
    QuotationForm,
  },
  setup() {
    const quotationForm = useCreateQuotationForm();

    const handleUpdateField = (field: string, value: string | number | null) => {
      if (field === "date") quotationForm.form.date = String(value ?? "");
      if (field === "reference_no") quotationForm.form.reference_no = String(value ?? "");
      if (field === "customer_id") quotationForm.form.customer_id = value === null ? null : Number(value);
      if (field === "warehouse_id") quotationForm.form.warehouse_id = value === null ? null : Number(value);
      if (field === "status") quotationForm.form.status = String(value ?? "pending");
      if (field === "note") quotationForm.form.note = String(value ?? "");
      if (field === "tax") quotationForm.form.tax = Number(value ?? 0);
      if (field === "tax_type") quotationForm.form.tax_type = (value === "percentage" ? "percentage" : "fixed");
      if (field === "discount") quotationForm.form.discount = Number(value ?? 0);
      if (field === "discount_type") quotationForm.form.discount_type = (value === "percentage" ? "percentage" : "fixed");
      if (field === "shipping") quotationForm.form.shipping = Number(value ?? 0);
    };

    const handleSearchInput = async (value: string) => {
      quotationForm.searchQuery.value = value;
      await quotationForm.handleSearch();
    };

    return {
      ...quotationForm,
      handleUpdateField,
      handleSearchInput,
    };
  },
});
</script>
